import API from "@/services/api/api.service";
import { Consent, ConsentVersion } from "@/utils/models/consent.model";
import { RouteLocationNormalized } from "vue-router";

export const consentResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        const res = await API.getConsent(to.params.id as string);
        to.meta.consent = res.data.data;
    } catch (error) {
        console.error('CONSENT_RESOLVER_ERROR');
        return { name: 'Consents' };
    }
}